import { Action } from '@ngrx/store';
import { IArticle, IArticleQuery, IArticles } from '@shared/shared/interfaces/article.interfaces';

// Get data for all articles
export const GET_ALL_ARTICLES = '[Articles] Get All Articles';
export const GET_ALL_ARTICLES_FAIL = '[Articles] Get All Articles Fail';
export const GET_ALL_ARTICLES_SUCCESS = '[Articles] Get All Articles Success';

export class GetAllArticles implements Action {
  readonly type = GET_ALL_ARTICLES;
  constructor(public payload: IArticleQuery) {}
}

export class GetAllArticlesFail implements Action {
  readonly type = GET_ALL_ARTICLES_FAIL;
  constructor(public payload: any) {}
}

export class GetAllArticlesSuccess implements Action {
  readonly type = GET_ALL_ARTICLES_SUCCESS;
  constructor(public payload: IArticles) {}
}

// View a single article
export const VIEW_ARTICLE = '[Articles] View Article';
export const VIEW_ARTICLE_FAIL = '[Articles] View Article Fail';
export const VIEW_ARTICLE_SUCCESS = '[Articles] View Article Success';

export class ViewArticle implements Action {
  readonly type = VIEW_ARTICLE;
  constructor(public payload: string) {}
}

export class ViewArticleFail implements Action {
  readonly type = VIEW_ARTICLE_FAIL;
  constructor(public payload: any) {}
}

export class ViewArticleSuccess implements Action {
  readonly type = VIEW_ARTICLE_SUCCESS;
  constructor(public payload: IArticle) {}
}

export const CLEAR_ARTICLE = '[Articles] Clear Article';
export const CLEAR_ALL_ARTICLES = '[Articles] Clear All Articles';

export class ClearArticle implements Action {
  readonly type = CLEAR_ARTICLE;
}

export class ClearAllArticles implements Action {
  readonly type = CLEAR_ALL_ARTICLES;
}

export type ArticlesAction =
  | GetAllArticles
  | GetAllArticlesFail
  | GetAllArticlesSuccess
  | ViewArticle
  | ViewArticleFail
  | ViewArticleSuccess
  | ClearArticle
  | ClearAllArticles;
